export default __webpack_public_path__ + "static/media/payment-logo.3fcbf562.png";